module.exports = __webpack_public_path__ + "img/li.f3025538.png";